export default "__VITE_ASSET__D2nJ565K__"